import { render, staticRenderFns } from "./CurrentPlanCardSection.vue?vue&type=template&id=07f43709&scoped=true"
import script from "./CurrentPlanCardSection.vue?vue&type=script&lang=ts"
export * from "./CurrentPlanCardSection.vue?vue&type=script&lang=ts"
import style0 from "./CurrentPlanCardSection.vue?vue&type=style&index=0&id=07f43709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f43709",
  null
  
)

export default component.exports